// Created on 22.12.2022 By Sucheta Singha

import React, { Component } from 'react';
import { Route, Switch, Redirect, BrowserRouter } from 'react-router-dom';
import './scss/style.scss';
import VisitorManagerLogin from './views/project-files/visitor-management/VisitorManagerLogin';
import VisitorManagement from './views/project-files/visitor-management/VisitorManagement';
import AppCostCategory from './views/project-files/app-cost-calculator/AppCostCategory';
import BookAnAppointment from './views/project-files/book_appointment/book_appointment';
import FixedCostCalculator from './views/project-files/app-cost-calculator/FixedCostCalculator';
import CostContactForm from './views/project-files/app-cost-calculator/CostContactForm';
import MailSentDetails from './views/project-files/app-cost-calculator/MailSentDetails';
import BookTimeScheduled from './views/project-files/book_appointment/book_seduleList';
import HireYourOwnTeam from './views/project-files/app-cost-calculator/HireYourOwnTeam';
import UpdateCategoryExisting from './views/project-files/app-cost-calculator/UpdateCategoryExisting';
import VideoPortfolio from './views/project-files/video-portfolio/VideoPortfolio';
import VideoPortfolioContactForm from './views/project-files/video-portfolio/VideoPortfolioContactForm';
import VideoPortfolioVerifyOTP from './views/project-files/video-portfolio/VideoPortfolioVerifyOTP';
import VideoPortfolioDetails from './views/project-files/video-portfolio/VideoPortfolioDetails';
import OnBoardEmployeeLogin from './views/project-files/onboarding-management/OnBoardEmployeeLogin';
import OnBoardCandidateDetails from './views/project-files/onboarding-management/OnBoardCandidateDetails';
import OnBoardCandidateForm from './views/project-files/onboarding-management/OnBoardCandidateForm';
import TrackerLocation from './views/project-files/screen-monitoring/TrackerLocation';

// import Page404 from './views/pages/login/Page404';

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const TheLayout = React.lazy(() => import('./containers/TheLayout'));

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'));
const VerifyOTP = React.lazy(() => import('./views/pages/login/VerifyOTP'));
const ForgotPasswordOTP = React.lazy(() => import('./views/pages/login/ForgotPasswordOTP'));
const ResetPassword = React.lazy(() => import('./views/pages/login/ResetPassword'));
const ChangePassword = React.lazy(() => import('./views/pages/login/ChangePassword'));

const SignInMasterPage = React.lazy(() => import('./views/pages/login/SignInMasterPage'));

// function to guard the component for private access
const authGuard = (Component) => () => {
  return localStorage.getItem("hrms_employee_auth") ? (
    <Component />
  ) : (<Redirect to="/login" />)

};

const authGuardVisitorManager = (Component) => () => {
  return localStorage.getItem("visitor_manager_auth_token") ? (
    (<VisitorManagement />)
  ) : (<Redirect to="/visitor-book" />)

};

const authGuardOnboardingManagement = (Component) => () => {
  return localStorage.getItem("candidate_onboard_auth_token") ? (
    (<OnBoardCandidateDetails />)
  ) : (<Redirect to={`/onboarding-candidate/${localStorage.getItem("candidate_onboard_token")}`} />)

};


class App extends Component {

  render() {
    return (
      // <BrowserRouter basename="/ems-web">  //For local staging (HTTPS)
      <BrowserRouter basename={process.env.REACT_APP_WEB_PLATFORM_HOMEPAGE}>
        <React.Suspense fallback={loading}>
          <Switch>
            {/* <Route exact path="/login" name="Login Page" render={props => <Login {...props} />} /> */}
            <Route exact path="/login" name="Login Page" render={props => <SignInMasterPage {...props} />} />

            <Route exact path="/visitor-book" name="Visitor Book" render={props => <VisitorManagerLogin {...props} />} />
            {/* <Route exact path="/onboarding-candidate/:token" name="Onboarding Management" render={props => <OnBoardEmployeeLogin {...props} />} /> */}
            <Route exact path="/onboarding-candidate/:token" name="Onboarding Management" component={OnBoardEmployeeLogin}/>
            <Route exact path="/app-cost-category" name="App Cost Calculator" component={AppCostCategory} />
            <Route exact path="/fixed-cost-calculator/:category_id/:service_id" name="App Cost Calculator" component={FixedCostCalculator} />
            <Route exact path="/contact-form/:page_name" name="Contact Form" component={CostContactForm} />
            <Route exact path="/mail-sent-details" name="Contact Form" component={MailSentDetails} />
            <Route exact path="/hire-your-own-team/:category_id/:service_id" name="Contact Form" component={HireYourOwnTeam} />
            <Route exact path="/update-category-existing/:category_id/:service_id" name="Update App Existing" component={UpdateCategoryExisting} />

            <Route exact path="/visitor" name="Visitor Management" render={authGuardVisitorManager(props => <VisitorManagement {...props} />)} />
            <Route exact path="/onboarding-details" name="Onboarding Management" component={OnBoardCandidateDetails} />
            <Route exact path="/onboarding-form" name="Onboarding Management" component={OnBoardCandidateForm} />

            <Route exact path="/book-appointment" name="Book An Appointment" component={BookAnAppointment} />
            <Route exact path="/book-time-scheduled" name="Book Scheduled" component={BookTimeScheduled} />
            <Route exact path="/video-portfolio" name="Video Portfolio" component={VideoPortfolio} />
            <Route exact path="/video-portfolio-contact" name="Video Portfolio" component={VideoPortfolioContactForm} />
            <Route exact path="/video-portfolio-verify-otp" name="Video Portfolio" component={VideoPortfolioVerifyOTP} />
            <Route exact path="/video-portfolio-details" name="Video Portfolio" component={VideoPortfolioDetails} />
            {/* <Route exact path="/404" name="Video Portfolio" component={Page404} /> */}
            <Route exact path="/tracker-location" name="Tracker Location" component={TrackerLocation} />

            <Route exact path="/verify-otp" name="Verify OTP" render={props => <VerifyOTP {...props} />} />
            <Route exact path="/forgot-password-otp" name="Forgot Password OTP" render={props => <ForgotPasswordOTP {...props} />} />
            <Route exact path="/reset-password" name="Reset Password" render={props => <ResetPassword {...props} />} />
            <Route exact path="/change-password" name="Reset Password" render={props => <ChangePassword {...props} />} />
            <Route path="/" name="Home" render={authGuard(props => <TheLayout {...props} />)} />


          </Switch>
        </React.Suspense>
      </BrowserRouter>
    );
  }
}

export default App;
